module.exports = __webpack_public_path__ + "static/media/mail.9d4a2776.svg";